let config = [{
  name: 'secondplace',
  label: 'Zweitbeste',
  description: 'lorem ipsum ...'
}, {
  name: 'thirdplace',
  label: 'Platz drei',
  description: 'lorem ipsum ...',
  text: `
    Lorem ipsum dolor sit amet, <strong>consectetur adipiscing elit,</strong>
    sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.
    Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea
    ommodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore
    u fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui
    officia deserunt mollit anim id est laborum.
  `
}, {
  name: 'close',
  label: 'Knappes Rennen',
  description: 'lorem ipsum ...'
}, {
  name: 'change',
  label: 'Wechselwähler',
  description: 'lorem ipsum ...'
}, {
  name: 'true',
  label: 'Ehrliche Wahlkarte',
  description: 'lorem ipsum ...',
  text: `
    Ein Text
  `,
  calculateResult: true
}];

// add area based analysis parts
if (baseconfig.analysis) {
  config = config.concat(baseconfig.analysis);
}

export default config;
